/**
 * Helper functions headers.js
 *
 * @namespace headers
 * @date
 * @author
 * @copyright UniWeb bvba 2024
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/helper/arrays.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export function getFilenameFromContentDispositionLegacy(contentDisposition) {
    if (!contentDisposition) {
        return null;
    }

    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(contentDisposition);
    if (matches != null && matches[1]) {
        return matches[1].replace(/['"]/g, '');
    }
    return null;
}

export function getFilenameFromContentDispositionModern(contentDisposition) {
    if (!contentDisposition) {
        return null;
    }

    const filenameStarRegex = /filename\*=([^;]*)/;
    const matches = filenameStarRegex.exec(contentDisposition);
    if (matches != null && matches[1]) {
        let parts = matches[1].split("''"); // Split charset and encoded filename
        if (parts.length === 2) {
            return decodeURIComponent(parts[1]);
        }
    }
    return null;
}

export function getFilenameFromContentDisposition(contentDisposition) {
    const modern = getFilenameFromContentDispositionModern(contentDisposition);

    console.log('modern', modern);

    if (modern) {
        return modern;
    }

    return getFilenameFromContentDispositionLegacy(contentDisposition);
}